module.exports = {
  lintOnSave: false,
  publicPath: '/ecanaldenuncias',
  transpileDependencies: ['vuetify'],

  pluginOptions: {
    i18n: {
      locale: 'es',
      fallbackLocale: 'es',
      localeDir: 'locales',
      enableInSFC: true,
    },
  },
  devServer: {
    host: process.env.VUE_DOMAIN_NAME,
    port: process.env.VUE_PORT_SERVER,
    hot: true,
    disableHostCheck: true,
    proxy: {
      '/wscomun': {
        target: 'http://erpws.des.expertxrm.com/'
      },
    }
  },
  chainWebpack: config => {
    if (process.env.NODE_ENV === 'production') {
      config.module.rule('vue').uses.delete('cache-loader');
      config.module.rule('js').uses.delete('cache-loader');
      config.module.rule('ts').uses.delete('cache-loader');
      config.module.rule('tsx').uses.delete('cache-loader');
    }
  }
}
